// @flow

import Bugsnag from '@bugsnag/js'
import * as React from 'react'

import { Context as AuthContext } from '@toggl/auth'
import {
  PluginReact,
  connectivity,
  tracer,
  uptime,
  verbose,
} from '@toggl/bugsnag'
import { MDXProvider } from 'components'

import ErrorPage from '../components/ErrorPage'

declare var process: WebProcess

const environment = process.env.GATSBY_BUGSNAG_RELEASE_STAGE

Bugsnag.start({
  apiKey: process.env.GATSBY_BUGSNAG_API_KEY,
  appVersion: process.env.GATSBY_VERSION,
  enabledReleaseStages: [
    ('preview': BugsnagReleaseStage),
    ('production': BugsnagReleaseStage),
    ('staging': BugsnagReleaseStage),
  ],
  releaseStage: environment,

  // Disabled due to privacy concerns #6362 (https://git.io/vNClt).
  // If you believe they're now safe, reconsider enabling 💪!
  enabledBreadcrumbTypes:
    environment === ('production': BugsnagReleaseStage)
      ? []
      : [
          'navigation',
          'request',
          'process',
          'log',
          'user',
          'state',
          'error',
          'manual',
        ],

  autoTrackSessions: environment !== ('testing': BugsnagReleaseStage),
  autoDetectErrors: true,
  collectUserIp: false,
  logger:
    environment === ('production': BugsnagReleaseStage) ? null : verbose.logger,

  metadata: {
    connectivity: {
      interruptions: false,
      offline: false,
    },
  },

  onError:
    environment === ('production': BugsnagReleaseStage)
      ? null
      : verbose.onError,

  plugins: [new PluginReact(React), connectivity, uptime(), tracer],
})

const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary()

export const Provider = ({
  children,
}: {
  children: React.Node,
}): React.Element<typeof ErrorBoundary> => {
  return (
    <ErrorBoundary FallbackComponent={ErrorPage}>
      <AuthContext.Provider>
        <MDXProvider>{children}</MDXProvider>
      </AuthContext.Provider>
    </ErrorBoundary>
  )
}
